module.exports = __webpack_public_path__ + "static/Dentures 2 intraoral after-776a9c7aed01fcbb791319543fc3fa25.jpg";